export const HTTP_RETRY_DELAYS_MS = [800, 1600, 3200] as const;

export const HTTP_RETRY_BUDGET_MS = HTTP_RETRY_DELAYS_MS.reduce((total, delay) => total + delay, 0);

export function getHttpRetryDelay(retryCount: number): number {
    return HTTP_RETRY_DELAYS_MS[retryCount - 1] ?? 0;
}
